export const GuestLayoutConfig = {
  maxWidth: '400px',
};

export const MemberLayoutConfig = {
  leftSidebarWidth: '275px',
  leftSidebarWidthMin: '90px',
  rightSidebarWidth: '350px',
  rightSidebarWidthMin: '320px',
};
